 <app-base-header
  [ngClass]="{'ion-hide': !loggedIn || (!auth.hasAnyCustomClaims((auth.customClaims$ | async), ['manager', 'finance']) && (payeeService.signedInPayee$ | async) === null), 'ion-hide-lg-down': !(contractService.contractAgreementRequired$ | async)}"
  [hideForLg]="false"
 />

@if (contractService.showSpinner$ | async) {
  <div class="ion-text-center">
    <ion-spinner class="spinner" color="primary" name="lines" class="spinner" />
  </div>
}

@if (contractService.agreementUpdateRequired$ | async) {
  <div class="required-info max-width">
  <ion-note color="danger">
    O contrato foi atualizado. Para continuar utilizando a plataforma, você deve aceitar os novos termos.
  </ion-note>
</div>
}

<ion-content [ngClass]="{'ion-hide': !(contractService.contractAgreementRequired$ | async)}" class="padding-top">
  <div id="ds-clickwrap"></div>
</ion-content>

<ion-content>
  @if (!(contractService.contractAgreementRequired$ | async)) {
    @if ((payeeService.signedInPayee$ | async) || !loggedIn || auth.hasAnyCustomClaims((auth.customClaims$ | async), ['manager', 'finance']); as payee) {
      <div [ngClass]="{'logged-in': loggedIn}">
        <ion-router-outlet id="main" class="main-container" />
      </div>
    } @else {
      <div class="ion-text-center">
        <ion-spinner class="spinner" color="primary" name="lines" class="spinner" />
      </div>
    }
  }
</ion-content>